import React from 'react'
import classnames from "classnames";
import baseStyles from 'custom/base.styl';

export default (props) => (
  <div className={classnames(baseStyles.loader, {[baseStyles.absolute]: props.absolute})}>
    <i className={classnames(baseStyles.large)}/>
  </div>
)




// WEBPACK FOOTER //
// ./src/components/shared/Loader.js